export default "__VITE_ASSET__DRJ2au4$__"